import type { LIST_TYPES } from 'hb-builder/components/BuilderComponents/dynamic/List/ListLayouts/types';

export const getUrlToIndexPage = ({
  networkRootUrl,
  topicId,
  type,
  whiteLabelUrl,
}: {
  networkRootUrl?: string | null;
  topicId?: number | null;
  type: LIST_TYPES;
  whiteLabelUrl?: string | null;
}) => {
  const LINKS = Object.freeze({
    events: whiteLabelUrl
      ? `https://${whiteLabelUrl}/events`
      : topicId
      ? Routes.topic_events_index_path(topicId)
      : Routes.events_path(),
    news: whiteLabelUrl
      ? `https://${whiteLabelUrl}/news`
      : topicId
      ? Routes.topic_news_index_path(topicId)
      : Routes.news_path(),
    topics: whiteLabelUrl ? `${networkRootUrl}/topics` : Routes.topics_path(),
  });

  return LINKS[type];
};
